import React from 'react';
import WhatWeDoBox from './WhatWeDoBox';
import R from 'ramda';
import {mapIndexed} from '../resources/utils/utilities';
import './WhatWeDo.css'


class WhatWeDo extends React.Component {
  render() {
    const whatWeDoComponent = (chunked, index) => <WhatWeDoBox item={chunked} key={index} />

    return (
      <span>
        {R.compose(mapIndexed(whatWeDoComponent), R.splitEvery(3))(R.prop('items', this.props))}
      </span>
    )
  }
}

WhatWeDo.propTypes = {
  items: React.PropTypes.array.isRequired
}

export default WhatWeDo;



// WEBPACK FOOTER //
// ./src/components/WhatWeDo.js